import { z } from 'zod';

export const linkFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  url: z.string()
    .url('Debe ser una URL válida')
    .max(500, 'La URL debe tener máximo 500 caracteres'),
  description: z.string()
    .max(1000, 'La descripción debe tener máximo 1000 caracteres')
    .optional()
    .or(z.literal('')),
  group_name: z.string()
    .max(100, 'El nombre del grupo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  icon_url: z.string()
    .url('Debe ser una URL válida')
    .max(255, 'La URL del icono debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  display_order: z.number()
    .int('Debe ser un número entero')
    .min(0, 'El orden debe ser mayor o igual a 0')
    .default(0),
  is_active: z.boolean().default(true),
});

export type LinkFormData = z.infer<typeof linkFormSchema>;
